import { Component, Input } from '@angular/core';

/**
 * Message component for showing error or success messages for when the connection
 * state changes
 */
@Component({
    selector: 'ngx-remote-desktop-message',
    template: `
    `
})
export class MessageComponent {

    /**
     * Title of the message to display
     */
    @Input()
    public title: string;

    /**
     * Content of the message to display
     */
    @Input()
    public message: string;

    /**
     * Message type. Can be 'success' or 'error'
     */
    @Input()
    public type = 'success';
}
